// Preserve a short local lead-in; keep internal pauses once speech has started.
export function createSpeechOnsetBuffer(write, maxLeadSamples = 8000) {
  let frames = []
  let samples = 0
  let opened = false
  return {
    push(frame) {
      const copy = new Float32Array(frame)
      if (opened) { write(copy); return }
      frames.push(copy)
      samples += copy.length
      while (samples > maxLeadSamples && frames.length > 1) samples -= frames.shift().length
    },
    open() {
      if (opened) return
      opened = true
      frames.forEach(write)
      frames = []
      samples = 0
    }
  }
}
